import { Alert, AlertDescription } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { AlertTriangle } from 'lucide-react'
import { openCheckout } from '@/hooks/useBilling'

interface CancellingBannerProps {
  orgId: string
  orgSlug: string
  currentPeriodEndsAt: string | null
}

export function CancellingBanner({ orgId, orgSlug, currentPeriodEndsAt }: CancellingBannerProps) {
  const endDate = currentPeriodEndsAt
    ? new Date(currentPeriodEndsAt).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })
    : null

  return (
    <Alert className="rounded-none border-x-0 border-t-0 bg-amber-50 border-amber-200 text-amber-900">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="flex items-center justify-between w-full">
        <span>
          Your subscription has been cancelled.
          {endDate ? ` You have full access until ${endDate}.` : ''}{' '}
          After that, your account will be locked.
        </span>
        <Button
          size="sm"
          variant="outline"
          className="ml-4 shrink-0 border-amber-400 text-amber-900 hover:bg-amber-100"
          onClick={() => openCheckout(orgId, orgSlug)}
        >
          Resubscribe
        </Button>
      </AlertDescription>
    </Alert>
  )
}
